import { render, staticRenderFns } from "./VButtonBack.vue?vue&type=template&id=cb7a769c&"
import script from "./VButtonBack.vue?vue&type=script&lang=ts&"
export * from "./VButtonBack.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonBack.vue?vue&type=style&index=0&id=cb7a769c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports